
import { Vue, Component } from 'vue-property-decorator';
import NewsList from '@/components/NewsList.vue';
import Banner from '@/components/Banner.vue';
import * as config from '../config';

@Component({
  components: { NewsList, Banner },
})
export default class NewsPage extends Vue {
  option = config.OPTHINES;
  bannerSrc = require('../assets/banner.png');
}
